/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import Select from "react-select";
import Moment from "moment";
import {
  Button,
  ButtonToolbar,
  Modal,
  Table,
  Form,
  Col,
} from "react-bootstrap";
import swal from "sweetalert";
import { NoticeManajemenUser } from "../../../../../_metronic/_partials/controls";
import { Link } from "react-router-dom";
import AppConfig from "../../../../config/AppConfig";

class ManajemenUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal1 = this.closeModal1.bind(this);
    this.closeModal2 = this.closeModal2.bind(this);
    this.modalAddURole = this.modalAddURole.bind(this);
    this.modalURole = this.modalURole.bind(this);
  }
  state = {
    // MODAL ============================
    modalAddURole: false,
    modalURole: false,
    // ==================================
    loadingBtn: false,
    loadingForm: true,
    loadingList: true,
    loadingDetails: true,
    // ==================================
    getUserRoles: [],
    getRoles: [],
    getUnits: [],
    errors: [],
    // FORM Add User
    nm_pengguna: "",
    alamat: "",
    jenis_kelamin: "",
    no_tel: "",
    username: "",
    no_hp: "",
    password: "",
    passwordconf: "",
    ym: "",
    tempat_lahir: "",
    skype: "",
    tgl_lahir: "",
    a_aktif: "",
    jabatan: "",
    // FORM Add User Role
    id_pengguna: "",
    id_peran: "",
    id_bp: "",
    id_unit: "",
    id_organisasi: "",
    no_sk_penugasan: "",
    tanggal_penugasan: "",
  };

  closeModal1() {
    this.setState({
      modalURole: false,
      loadingBtn: false,
    });
  }

  closeModal2() {
    this.setState({
      modalAddURole: false,
      id_unit: "",
      id_peran: "",
      id_bp: "",
      no_sk_penugasan: "",
      tanggal_penugasan: "",
      loadingBtn: false,
    });
  }

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  selectedGender = (val) => {
    this.setState({
      jenis_kelamin: val.value,
    });
  };
  selectedRole = (val) => {
    console.log(val.value);
    this.setState({
      id_peran: val.value,
    });
  };
  selectedBp = (val) => {
    this.setState({ val });
    this.setState({
      id_bp: val.value,
    });
  };
  selectedUnit = (val) => {
    this.setState({
      id_unit: val.value,
    });
  };

  componentDidMount() {
    // const timer = setTimeout(() => this.setState({ loadingForm: false }), 1000);
    // return () => clearTimeout(timer);
    const userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    if (sessiondata.i_isedit === 1) {
      let id = userdata.id_pengguna;
      axios
        .get(AppConfig.DetailsManajemenUser + id)
        .then((res) => {
          this.setState(
            {
              loadingForm: false,
              username: res.data.result.data.username,
              id_pengguna: id,
              nm_pengguna: res.data.result.data.nm_pengguna,
              tempat_lahir:
                res.data.result.data.tempat_lahir !== "null"
                  ? res.data.result.data.tempat_lahir
                  : "",
              tgl_lahir:
                res.data.result.data.tgl_lahir !== "null"
                  ? Moment(res.data.result.data.tgl_lahir).format("YYYY-MM-DD")
                  : "",
              jenis_kelamin:
                res.data.result.data.jenis_kelamin !== "null"
                  ? res.data.result.data.jenis_kelamin
                  : "",
              alamat:
                res.data.result.data.alamat !== "null"
                  ? res.data.result.data.alamat
                  : "",
              ym:
                res.data.result.data.ym !== "null"
                  ? res.data.result.data.ym
                  : "",
              skype:
                res.data.result.data.skype !== "null"
                  ? res.data.result.data.skype
                  : "",
              no_tel:
                res.data.result.data.no_tel !== "null"
                  ? res.data.result.data.no_tel
                  : "",
              no_hp:
                res.data.result.data.no_hp !== "null"
                  ? res.data.result.data.no_hp
                  : "",
            },
            () => {
              console.log(res);
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      window.history.back();
    }
  }

  validateForm() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.nm_pengguna) {
      formIsValid = false;
      errors["nm_pengguna"] = "Isian nama user tidak boleh kosong.";
    }

    if (!this.state.ym) {
      formIsValid = false;
      errors["ym"] = "Isian email tidak boleh kosong.";
    }

    if (!this.state.no_hp) {
      formIsValid = false;
      errors["no_hp"] = "Isian no.hp tidak boleh kosong.";
    }

    if (this.state.password !== "") {
      if (!this.state.passwordconf) {
        formIsValid = false;
        errors["passwordconf"] =
          "Isian konfirmasi password tidak boleh kosong.";
      } else if (this.state.passwordconf !== this.state.password) {
        formIsValid = false;
        errors["passwordconf"] = "Isian konfirmasi password tidak sesuai.";
      }
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  // Submit User ============================================================================
  handleSave = (e) => {
    e.preventDefault();
    e.target.className += " was-validated";
    if (this.validateForm()) {
      const {
        nm_pengguna,
        alamat,
        jenis_kelamin,
        no_tel,
        no_hp,
        password,
        passwordconf,
        ym,
        tempat_lahir,
        skype,
        tgl_lahir,
      } = this.state;
      this.setState({ loadingBtn: true });
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          // "?token="+userdata.token+`
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      var formData = new FormData();
      formData.append("data[id_pengguna]", userdata.id_pengguna);
      formData.append("data[nm_pengguna]", nm_pengguna);
      formData.append("data[ym]", ym);
      formData.append("data[no_hp]", no_hp);
      if (password !== "" && passwordconf !== "") {
        formData.append("data[password]", password);
        formData.append("data[passwordconf]", passwordconf);
      }
      axios
        .put(AppConfig.UpdateManajemenUser + session, formData)
        .then((res) => {
          this.setState({
            loadingBtn: false,
          });
          if (res.data.status === "sukses") {
            userdata.nm_pengguna = nm_pengguna;
            userdata.tempat_lahir = tempat_lahir;
            if (tgl_lahir !== "") {
              userdata.tgl_lahir = tgl_lahir;
            }
            userdata.jenis_kelamin = jenis_kelamin;
            userdata.alamat = alamat;
            userdata.ym = ym;
            userdata.skype = skype;
            userdata.no_tel = no_tel;
            userdata.no_hp = no_hp;
            localStorage.setItem("userdata", JSON.stringify(userdata));
            swal({
              title: "Sukses!",
              text: "Data anda berhasil diupdate!",
              icon: "success",
              button: "OK!",
            }).then(() => {
              window.location.reload();
            });
          } else {
            swal({
              title: "Gagal!",
              text: "Gagal update data!",
              icon: "error",
              button: "OK!",
            });
          }
        })
        .catch((err) => {
          this.setState({
            loadingBtn: false,
          });
          swal({
            title: "Gagal!",
            text: "Gagal menyimpan data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        });
    }
  };

  // List User Role ============================================================================
  modalURole = () => {
    console.log(this.state.id_pengguna);
    this.setState({ modalURole: true, loadingList: true });
    axios
      .get(AppConfig.ListRole + this.state.id_pengguna)
      .then((res) => {
        this.setState(
          {
            getUserRoles: res.data.result.role,
            loadingList: false,
          },
          () => {
            // console.log(this.state.getUserRoles);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Add User Role ============================================================================
  modalAddURole = () => {
    this.setState({ modalAddURole: true, loadingDetails: true });
    axios
      .get(AppConfig.AddRole + this.state.id_pengguna)
      .then((res) => {
        this.setState({
          getRoles: res.data.result.data2[0],
          getUnits: res.data.result.units[0],
          loadingDetails: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSubmitRole = (e) => {
    e.preventDefault();
    var formData = new FormData();
    this.setState({ loadingBtn: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_pengguna]", this.state.id_pengguna);
    formData.append("data[id_peran]", this.state.id_peran);
    formData.append("data[id_bp]", this.state.id_bp);
    formData.append("data[id_organisasi]", this.state.id_unit);
    axios
      .post(AppConfig.SaveRole, formData)
      .then((res) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Sukses!",
          text: "Role berhasil ditambahkan!",
          icon: "success",
          button: "OK!",
        });
        this.modalURole(this.state.id_pengguna);
        this.closeModal2();
      })
      .catch((err) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Gagal!",
          text: "Gagal menambah role!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };

  // Delete Role ============================================================================
  showDialogDelete(id_pengguna, idunit, idperan) {
    // console.log(idpengguna, idorganisasi, idperan);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let ids = id_pengguna + "/" + idunit + "/" + idperan;
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteRole + ids + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.modalURole(this.state.id_pengguna);
            this.closeModal2();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  render() {
    return (
      <>
        <NoticeManajemenUser style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Edit Profil</strong>
          <p>Pengaturan User SPMI</p>
        </NoticeManajemenUser>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <h2>Form Edit Profil</h2>
                </div>
              </div>
            </div>
          </div>
          {/*========================================== Form Add User ========================================== */}
          <Form
            className="needs-validation"
            onSubmit={this.handleSave}
            noValidate
          >
            {this.state.loadingForm === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* For turning off auto complete */}
                <input type="hidden" value="something" />
                <Form.Row>
                  <Form.Group as={Col} controlId="username">
                    <Form.Label>Username</Form.Label>
                    <p>{this.state.username}</p>
                  </Form.Group>
                  <Form.Group as={Col} controlId="nm_pengguna">
                    <Form.Label>
                      Nama Lengkap <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nama Lengkap"
                      value={this.state.nm_pengguna}
                      onChange={(e) => this.onInputForm(e, "nm_pengguna")}
                      required
                    />
                    <div className="invalid-feedback d-block">
                      {this.state.errors.nm_pengguna}
                    </div>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="no_hp">
                    <Form.Label>
                      No. HP (WhatsApp) <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="No. HP (WhatsApp)"
                      value={this.state.no_hp}
                      onChange={(e) => this.onInputForm(e, "no_hp")}
                      required
                    />
                    <div className="invalid-feedback d-block">
                      {this.state.errors.no_hp}
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} controlId="ym">
                    <Form.Label>
                      Alamat Email <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Alamat Email"
                      value={this.state.ym}
                      onChange={(e) => this.onInputForm(e, "ym")}
                      required
                    />
                    <div className="invalid-feedback d-block">
                      {this.state.errors.ym}
                    </div>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={this.state.password}
                      autoComplete="new-password"
                      onChange={(e) => this.onInputForm(e, "password")}
                    />
                    <div className="invalid-feedback d-block">
                      {this.state.errors.password}
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} controlId="passwordconf">
                    <Form.Label>Konfirmasi Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Konfirmasi Password"
                      value={this.state.passwordconf}
                      onChange={(e) => this.onInputForm(e, "passwordconf")}
                    />
                    <div className="invalid-feedback d-block">
                      {this.state.errors.passwordconf}
                    </div>
                  </Form.Group>
                </Form.Row>

                <div className="row">
                  <div className="col-md-12">
                    <div style={{ float: "right", marginLeft: "10px" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Button
                            disabled={this.state.loadingBtn}
                            variant="primary"
                            type="submit"
                          >
                            Simpan
                            {this.state.loadingBtn && (
                              <i className="ml-2 mr-1 spinner spinner-white"></i>
                            )}
                            &nbsp;&nbsp;
                          </Button>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
          {/*========================================== End Form ========================================== */}
        </Card>
      </>
    );
  }
}

export default ManajemenUser;
